import React, { useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTheme } from '../../context/ThemeContext';
import './Header.css';

const Header = ({ toggleSidebar }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { toggleTheme, isDark } = useTheme();
  const [showProfileMenu, setShowProfileMenu] = useState(false);

  // Dynamic Page Title
  const getPageTitle = () => {
    switch (location.pathname) {
      case '/dashboard':
        return 'Executive Dashboard';
      case '/daily-reporting':
        return 'Daily Work Reporting';
      case '/cheque-reporting':
        return 'Cheque Collection Reporting';
      case '/diwali-reporting':
        return 'Diwali Bonus Reporting';
      case '/profile':
        return 'Account Profile';
      case '/data-table':
        return 'All Reports Explorer';
      case '/reports/daily':
        return 'Submit Daily Report';
      case '/reports/check':
        return 'Submit Cheque Report';
      case '/reports/festive':
        return 'Submit Festive Report';
      case '/reports/offer':
        return 'Submit Offer Report';
      default:
        return 'AWPL Portal';
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    navigate('/login');
  };

  return (
    <header className="app-header">
      <div className="header-left">
        <button
          className="menu-toggle-btn"
          onClick={toggleSidebar}
          aria-label="Toggle navigation menu"
        >
          <span className="menu-icon">☰</span>
        </button>
        <div className="header-breadcrumb">
          <span className="breadcrumb-brand">AWPL</span>
          <span className="breadcrumb-separator">/</span>
          <span className="breadcrumb-current">{getPageTitle()}</span>
        </div>
      </div>

      <div className="header-right">
        {/* Theme Toggle Button */}
        <button
          className="theme-toggle-btn"
          onClick={toggleTheme}
          title={`Switch to ${isDark ? 'Light' : 'Dark'} Mode`}
          aria-label="Toggle dark/light theme"
        >
          <span className="theme-icon">{isDark ? '☀️' : '🌙'}</span>
          <span className="theme-label">{isDark ? 'Light' : 'Dark'}</span>
        </button>

        {/* Profile Dropdown */}
        <Dropdown align="end" show={showProfileMenu} onToggle={setShowProfileMenu}>
          <Dropdown.Toggle as="div" className="profile-dropdown-toggle">
            <div className="header-profile">
              <div className="profile-avatar">👨‍💼</div>
              <div className="profile-meta">
                <span className="profile-name">Leader Account</span>
                <span className="profile-role">Active Session</span>
              </div>
              <span className="dropdown-caret">▾</span>
            </div>
          </Dropdown.Toggle>

          <Dropdown.Menu className="custom-dropdown-menu">
            <div className="dropdown-header-box">
              <div className="dropdown-avatar-lg">👨‍💼</div>
              <div className="dropdown-user-details">
                <div className="dropdown-user-name">Authorized Leader</div>
                <div className="dropdown-user-status">● Logged In</div>
              </div>
            </div>

            <div className="dropdown-items-group">
              <Dropdown.Item onClick={() => navigate('/dashboard')}>
                <span className="dropdown-item-icon">📊</span>
                <span>Dashboard</span>
              </Dropdown.Item>
              <Dropdown.Item onClick={() => navigate('/profile')}>
                <span className="dropdown-item-icon">👤</span>
                <span>My Profile</span>
              </Dropdown.Item>
              <Dropdown.Item onClick={() => navigate('/daily-reporting')}>
                <span className="dropdown-item-icon">📝</span>
                <span>Daily Reports</span>
              </Dropdown.Item>
            </div>

            <Dropdown.Divider />

            <Dropdown.Item onClick={handleLogout} className="logout-dropdown-item">
              <span className="dropdown-item-icon">🚪</span>
              <span>Sign Out</span>
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </header>
  );
};

export default Header;
